import React from 'react';
import myImage from './kachel_nischendusche.jpg';

const kachelNischendusche = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelNischendusche;



